import http, { 
    createServer, Server, Agent} from 'node:http';
import net from 'node:net';
import zlib from 'node:zlib';

let requestPayload: string | Buffer;

let responseStatusCode: number;
let responseHeaders: any;
let responseBody: string | Buffer;

let netClient: net.Socket;

let serverPort: number = 3000;

export let proxyServer: Server;
export let proxyAgent: Agent = new Agent({
    keepAlive: true
});
(proxyAgent as any).createConnection = (options: any, callback: any) => {
    options.host = '127.0.0.1';
    options.port = 3000;

    const socket = new net.Socket();
    socket.connect(options.port, options.hostname, () => {
      callback(null, socket);
    });
    return socket;
  };

http.globalAgent = proxyAgent;

/**
 * 
 * @param url 
 * @returns 
 */
export const justMock = (url: string) => {
    proxyServer = createServer((clientReq, clientRes) => {
        const { headers } = clientReq;
        const acceptEncoding = headers['accept-encoding'] ?? headers['Accept-Encoding'];

        if(acceptEncoding?.includes('gzip')) {
            const gzip = zlib.createGzip();

            clientRes.setHeader('Content-Encoding', 'gzip');
            clientRes.setHeader('Content-Type', 'application/json');
            clientRes.writeHead(responseStatusCode, '', headers);

            gzip.pipe(clientRes);
            gzip.end(responseBody);
        } else {
            clientRes.statusCode = responseStatusCode;
            clientRes.end(JSON.stringify(responseBody));
        }

        let body = Buffer.alloc(0);

        clientReq.on('data', (chunk) => {
            body = Buffer.concat([body, chunk]);
        })

        clientReq.on('end', () => {
            requestPayload = Buffer.from(body).toString('utf-8');
        })
    });
    
    netClient = net.createConnection({
        port: serverPort
    }, () => {
        netClient.end();
    });

    netClient.on('error', (error) => {
        if(error.message.includes('ECONNREFUSED')) {
            proxyServer.close(()=> {
                proxyServer.listen(serverPort, () => {
                    netClient.end();
                });
            });
        }

        netClient.destroy();
    });

    proxyServer.on('error', (error) => {
        if(error.message.includes('EADDRINUSE')) {
            proxyServer.close(() => {
                proxyServer.listen(serverPort, () => {
                    netClient.end();
                });
            });
        }
    })

    return {
        ...baseReturnObj(),
        post,
        put,
        get,
        del,
        done
    }
}

/**
 * 
 * @param statusCode 
 * @returns 
 */
export const post = (statusCode: number) => {
    responseStatusCode = statusCode;

    return {
        ...baseReturnObj()
    }
}

/**
 * 
 * @param statusCode 
 * @returns 
 */
export const put = (statusCode: number) => {
    responseStatusCode = statusCode;

    return {
        ...baseReturnObj()
    }
}

/**
 * 
 * @param statusCode 
 * @returns 
 */
export const get = (statusCode: number) => {
    responseStatusCode = statusCode;

    return {
        ...baseReturnObj()
    }
}

/**
 * 
 * @param statusCode 
 * @returns 
 */
export const del = (statusCode: number) => {
    responseStatusCode = statusCode;

    return {
        ...baseReturnObj()
    }
}

/**
 * Setting the response mock
 * @param body 
 * @param headers 
 * @returns 
 */
export const response = (body: string | Buffer, headers?: any) => {
    responseBody = body;

    if(headers) {
        responseHeaders = headers;
    }

    return {
        done,
        getRequestPayload
    }
}

/**
 * Ends the mocking
 */
export const done = () => {
    console.log(`Closing proxy server and network socket...`);

    proxyServer.close();
    proxyAgent.destroy();

    netClient.end();
    netClient.destroy();
}

/**
 * 
 * @returns 
 */
export const getRequestPayload = () => {
    return requestPayload;
}


const baseReturnObj = () => {
    return {
        response,
        getRequestPayload
    }
}